import axios from "axios"
import {Loading, Message} from "element-ui"
import {mySecKey} from "./tool"
import Vue from 'vue'

const request = axios.create({})
let loading = null



request.interceptors.request.use((config) => {
  const isLoading = config.isLoading !== undefined ? config.isLoading : true
  if (isLoading) {
    loading = Loading.service({
      lock: true,
      fullscreen: true,
      text: "loading..."
    })
  }
  config.headers.Authorization = mySecKey()
  return config
},  (error) => {
  loading && Vue.nextTick(() => {
    loading.close()
  })
  return Promise.reject(error)
})

request.interceptors.response.use((response) => {
  loading && Vue.nextTick(() => {
    loading.close()
  })
  const responseData = response.data

  if (responseData.code !== 200) {
    Message.warning(responseData.msg)
  }
  return { code: responseData.code, msg: responseData.msg, data: responseData.data }
}, (error) => {
  loading && Vue.nextTick(() => {
    loading.close()
  })
  return Promise.reject(error);
})

export const get = (url, params={}, isLoading = true) => {
  return request.get(url, {params: params, isLoading})
}

export const post = (url, postData, isLoading = true, config = {}) => {
  return request.post(url, postData, {...config, isLoading})
}

//类似go语言类似的处理异常方式
export const to = (promise) => {
  return promise
    .then(data => [null, data.code === 200 ? data.data : null])
    .catch(err => [err, undefined]);
}



